import { useState, useEffect } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'

// This ensures all links from the markdown have a target set to _blank
// taken from https://github.com/cure53/DOMPurify/tree/main/demos#hook-to-open-all-links-in-a-new-window-link
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  // set all elements owning target to target=_blank
  if ('target' in node) {
    node.setAttribute('target', '_blank')
  }
  // set non-HTML/MathML links to xlink:show=new
  if (
    !node.hasAttribute('target') &&
    (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
  ) {
    node.setAttribute('xlink:show', 'new')
  }
})

// Encapsulates all the logic around converting a markdown string into html
// used on components that do not need to use data from the question machine
const useSimpleMarkdown = (markdown = '') => {
  const [html, setHtml] = useState('')

  useEffect(() => {
    const sanitizedMarkup = DOMPurify.sanitize(marked.parseInline(markdown), { USE_PROFILES: { html: true } })
    setHtml(sanitizedMarkup)
  }, [markdown])
  return {
    sanitizedMarkup: html
  }
}

export default useSimpleMarkdown
